import { toast } from "react-toastify";
import { BANK, DATA_FETCH, ERROR_FETCH, ERROR_PINDATA, ERROR_UBO, FETCHED_PINDATA, FORMAT_DATE, FORMAT_DATE_TIME, GST, GST_DETAILS_MISSING, GST_ERROR_MSG, KYC_FILES, MAX_ACTIVE_UBO_COUNT, PAN, PAN_DETAILS_MISSING, UPLOAD_SUCEESS, VERIFY_ERROR, VERIFY_SUCCESS } from "./mle.constants";
import { basicFormDataRes, kycDocumentsUploadRes, UploadAndFetchRes, verifyPiiAccount } from "../../../mockApiWiseReqRes";
import { FETCH_BASIC_FORMDATA_SUCCESS, FETCH_KYC_DOCUMENTS_SUCCESS, FETCH_PINCODE_SUCCESS, GST_UPLOAD_AND_FETCH_SUCCESS, KYC_DOCUMENT_UPLOAD_SUCCESS, OWNERSHIP_DETAILS_FETCH, PAN_UPLOAD_AND_FETCH_SUCCESS, VERIFY_BANK_ACCOUNT_SUCCESS, VERIFY_GST_ACCOUNT_SUCCESS, VERIFY_PAN_ACCOUNT_SUCCESS } from "../../../mockApiWiseReqRes/mockApiWise.constants";
import { MOCK_API_VALUE } from "../../../utils/constants/commonValues";
import { GET, POST } from "../../../utils/fetchWrappers";
import { apiStatusCodes } from "../../../utils/API/apiStatusCodes";
import { API_FETCH_BASIC_DATA, API_UPLOAD_AND_FETCH_OCR, API_UPLOAD_KYC_DOCUMENT, API_VERIFY_PII_ACCOUNT_DETAILS, API_VIEW_KYC_DOCUMENT, APT_FETCH_MLE_DETAILS } from "utils/API/apiUrls";
import { BUSINESS_SECTION_TYPE_MLE, MAXIMUM_VALUE, MINIMUM_VALUE, MLE_CREATE_FORM_NAME, MLE_ENTITY_TYPE, mleFields, PREFIX_KYCURLS } from "./BusinessTab/contants";
import moment from "moment";
import { ERROR_MESSAGES } from "utils/constants/toastMessages";
import { UBO_SECTION_TYPE, uboDeclarationUrls, uboFields } from "./UobTab/constant";
import { fieldLevelValidators } from "utils/validators";
import { APPROVE } from "components/MleMakerChecker/constant";
import { createDeepCopyObj } from "utils/helperMethods";
import { EDITABLE } from "containers/MerchantLegalEntity/constants";


export const getDBUboCount = async (payload) => {
    try {
        const resp = await POST(APT_FETCH_MLE_DETAILS, payload);
        const data = resp.data;
        
        if (data?.statusCode === apiStatusCodes.SUCCESS2) {
           
            if (data?.ownershipDetailSection?.uboDetails?.length > 0) {
                
                return data?.ownershipDetailSection?.uboDetails?.length;
            }
        }
    } catch(e) {
        console.log("getDBUboCount error", e.message);
    }

    return 0;
}

export const fetchKycDocsS3Details = async payload => {
    let data = {};
    try {
        
        if (MOCK_API_VALUE) {
            
            data = basicFormDataRes(FETCH_KYC_DOCUMENTS_SUCCESS);
    
        } else {
            payload.entityCode = BUSINESS_SECTION_TYPE_MLE;
            const resp =  await POST(API_FETCH_BASIC_DATA, payload);
            data = resp.data;
        }
        
        if (data?.statusCode == apiStatusCodes.SUCCESS2) {
            // toast.success(DATA_FETCH);
        } else {
            toast.error(ERROR_FETCH);
        }
    } catch(e) {
        console.log("e fetchKycDocsS3Details", e.message);
        toast.error(ERROR_FETCH);
    }
    return data;
}

export const fetchPinCodeDetails = async payload => {
    let data = {};
    try {
        
        if (MOCK_API_VALUE) {
            
            data = basicFormDataRes(FETCH_PINCODE_SUCCESS);
    
        } else {
            payload.entityCode = BUSINESS_SECTION_TYPE_MLE;
            const resp =  await POST(API_FETCH_BASIC_DATA, payload);
            data = resp.data;
        }
        
        if (data?.statusCode == apiStatusCodes.SUCCESS2) {
            console.log("success")
            // toast.success(FETCHED_PINDATA);
        } else {
            toast.error(ERROR_PINDATA);
        }
    } catch(e) {
        console.log("e fetchPinCodeDetails", e.message);
        toast.error(ERROR_PINDATA);
    }   
    return data;
}



export const fetchBasicDataBusinessDetails = async payload => {
    let data = {};
    try {
        
        if (MOCK_API_VALUE) {
            
            data = basicFormDataRes(FETCH_BASIC_FORMDATA_SUCCESS);
    
        } else {
            const resp =  await POST(API_FETCH_BASIC_DATA, payload);
            data = resp.data;
        }
        // return {
        //     statusCode: "ASD-000"
        // }
        
        if (data?.statusCode == apiStatusCodes.SUCCESS2) {
            console.log("success")
            // toast.success(FETCHED_PINDATA);
        } else {
            toast.error(ERROR_PINDATA);
        }
    } catch(e) {
        console.log("e fetchPinCodeDetails", e.message);
        toast.error(ERROR_PINDATA);
    }   
    return data;
}

export const fetchOwnershipDetails = async payload => {
    let data = {};
    try {
        
        if (MOCK_API_VALUE) {
            
            data = basicFormDataRes(OWNERSHIP_DETAILS_FETCH);
    
        } else {
            payload.entityCode = UBO_SECTION_TYPE;
            const resp =  await POST(API_FETCH_BASIC_DATA, payload);
            data = resp.data;
        }
        
        if (data?.statusCode == apiStatusCodes.SUCCESS2) {
            console.log("success")
            // toast.success(FETCHED_PINDATA);
        } else {
            toast.error(ERROR_FETCH);
        }
    } catch(e) {
        console.log("e fetchPinCodeDetails", e.message);
        toast.error(ERROR_FETCH);
    }   
    return data;
}

// PII - Personal Identity Information (GST, PAN)
export const fetchPiiData = async (payload, type) => {
    let data = {};
    try {
        
        if (MOCK_API_VALUE) {
            
            let fetchType = PAN_UPLOAD_AND_FETCH_SUCCESS;
            if (type == GST) {
                fetchType = GST_UPLOAD_AND_FETCH_SUCCESS;
            }
            
            
            data = UploadAndFetchRes(fetchType);
    
        } else {
            const resp =  await POST(
                API_UPLOAD_AND_FETCH_OCR, 
                payload,
                {
                    'Content-Type': 'multipart/form-data;',
                },
                true
            );
            data = resp.data;
        }

        if (data?.statusCode == apiStatusCodes.SUCCESS4) {
            toast.success(UPLOAD_SUCEESS);
        } else if (data?.statusCode == apiStatusCodes.SUCCESS) {
            let successMsg = DATA_FETCH
            if ((type === GST && 
                (!data?.documentDetails?.gstNumber?.value ||
                data?.documentDetails?.gstNumber?.value == GST_ERROR_MSG)) || 
            (type === PAN && 
                (!data?.documentDetails?.panNumber?.value || 
                !data?.documentDetails?.name?.value ||
                !data?.documentDetails?.dob?.value))) {
                successMsg = UPLOAD_SUCEESS;
            }
            toast.success(successMsg);
        } else {
            toast.error(data.errorMessage ?? ERROR_FETCH);
        }
    } catch(e) {
        data = {errorMessage: e?.message || ""};
        console.log("fetchPiiData", e.message);
        toast.error(ERROR_FETCH);
    }
    return data;
}


/* Sample payload
{
  "verificationId" : "ABCDE1234L",
  "accountType": "BANK",
  "accountIdentifier": "123445332321334313",
  "accountCode": "CFCF1234567",
  "kycMetaData": {
    "name": "Jon Snow",
    "dob": "1990/11/25"
  }
}

 */
export const verifyAccountDetails = async (payload, type) => {
    let data = {};
    try {
        
        if (MOCK_API_VALUE) {
            
            let fetchType = VERIFY_GST_ACCOUNT_SUCCESS;
            if (type == PAN) {
                fetchType = VERIFY_PAN_ACCOUNT_SUCCESS;
            } else if (type == BANK) {
                fetchType = VERIFY_BANK_ACCOUNT_SUCCESS;
            }
            
            
            data = verifyPiiAccount(fetchType);
    
        } else {
            const resp =  await POST(API_VERIFY_PII_ACCOUNT_DETAILS, payload);
            data = resp.data;
        }
        
        if (data?.statusCode == apiStatusCodes.SUCCESS) {
            console.log("called success");
            // toast.success(VERIFY_SUCCESS);
        } else {
            toast.error(data.errorMessage ?? VERIFY_ERROR);
        }
    } catch(e) {
        data = {errorMessage: e?.message || ""};
        toast.error(VERIFY_ERROR);
    }
    return data;
}

export const verifyPanDetails = (panData) => {
    let {pan, panName, panDate} = panData;
    let error = ''
    if (!pan && !panName && !panDate) {
        error = PAN_DETAILS_MISSING;
    }
    return error;
}

export const verifyGstDetails = gst => {
    let error = '';
    if (!gst) {
        error = GST_DETAILS_MISSING;
    }
    return error;
}

const isObject = item => {
    if (typeof item === 'object'){
        return true;
    }
    return false;
}

function adjustDateToTimezone(dateData, timezoneOffset) {
    // Parse the original date
    const originalDate = (typeof dateData === 'string') ? moment(dateData).format(FORMAT_DATE) : dateData;
    
    // Adjust the date by applying the timezone offset
    // const adjustedDate = originalDate.utcOffset(timezoneOffset);
    
    // Return the formatted date
    return originalDate;
}

const updateDataToArr = (data) => {
    if(!data)return;
    if (Array.isArray(data)) {
        return data;
    }

    return [data];
}

export const mleSubmitDataFormat = ({
    formData, 
    uniqueIdentifier, 
    intentId,
    formType,
    sectionType
}) => {
    const requestData = {};
    // in case of single email
    requestData.uniqueIdentifier = (uniqueIdentifier) ? uniqueIdentifier : `MLE.${formData.emails}`;
    requestData.sectionType = (sectionType) ? sectionType : BUSINESS_SECTION_TYPE_MLE;
    requestData.formType = (formType) ? formType : MLE_CREATE_FORM_NAME;
    requestData.intentId = intentId;
    requestData.data = JSON.parse(JSON.stringify(formData));
    // validation
    // if (!!requestData.data.gstNumber && !requestData?.data?.gstUploadFile) {
    //     toast.error(GST_DETAILS_MISSING);
    //     return null;
    // }
    // if (!requestData.data.gstNumber && !!requestData?.data?.gstUploadFile) {
    //     toast.error(GST_DETAILS_MISSING);
    //     return null;
    // }

    // operations
    requestData.data.emails =  updateDataToArr(requestData.data.emails);
    requestData.data.gstNumber = updateDataToArr(requestData.data.gstNumber || []);
    requestData.data.websiteURLs = updateDataToArr(requestData.data.websiteURLs);
    requestData.data.mobileNumbers = updateDataToArr(requestData.data.mobileNumbers);
    requestData.data.telephoneNumbers = updateDataToArr(requestData.data.telephoneNumbers);
    requestData.data.turnoverAmount = requestData.data.turnoverAmount || "0";
    // requestData.data.source = requestData.data.source || "other"; // do not delete this comment.
    if (requestData.data.mandatoryDocs) {
        delete requestData.data.mandatoryDocs;
    }
    // if (requestData.data.gstNumber && !requestData.data.gstUploadFile) {
    //     toast.error(GST_DETAILS_MISSING);
    //     return;
    // }
    
    requestData.data.entityType = MLE_ENTITY_TYPE;
    delete requestData.data[MAXIMUM_VALUE];
    delete requestData.data[MINIMUM_VALUE];
    delete requestData.data.panurl;
    // requestData.data.merchantCategory = 'Retail';
    requestData.data.merchantType = 'Online';
    requestData.data.dateOfIncorporation = moment((requestData.data.dateOfIncorporation)).format(FORMAT_DATE)
    requestData.data.panDetails.dob = requestData.data.dateOfIncorporation;
    delete requestData.data[KYC_FILES];
    delete requestData.data?.optionalFields;

    if (!requestData?.data?.panDetails?.url) {
        delete requestData.data.panDetails.url;
    }
    
    
    // if (requestData?.data?.panNumberUpload) {
    //     delete requestData.data.panNumberUpload;
    // }
    
    if (!requestData?.data?.[PREFIX_KYCURLS]) {
        requestData.data[PREFIX_KYCURLS] = {}; 
    }
    if (requestData?.data?.gstUploadFile) {
        
        let gstUrl = requestData?.data?.gstUploadFile;
        requestData.data[PREFIX_KYCURLS]  = {
            ...requestData.data[PREFIX_KYCURLS],
            'GST': [gstUrl]
        }
    }
    delete requestData.data.gstUpload;
    delete requestData?.data?.gstUploadFile;
    if (requestData?.data?.merchantType)
        delete requestData.data.merchantType;
    if (requestData?.data?.editedDocCategory) 
        delete requestData.data.editedDocCategory;
    if (requestData?.data?.infoMsgs)
        delete requestData.data.infoMsgs;
    if (requestData?.data?.partiallyMandatoryDocs)
        delete requestData.data.partiallyMandatoryDocs;
    if (requestData?.data?.['verify-pan']) {
        delete requestData.data['verify-pan'];
    }
    if (requestData?.data?.['verify-gst']) {    
        delete requestData.data['verify-gst'];
    }
    Object.keys(requestData.data[PREFIX_KYCURLS]).map(item => {
        if (requestData.data[PREFIX_KYCURLS][item]&&!Array.isArray(requestData.data[PREFIX_KYCURLS][item])) {
            requestData.data[PREFIX_KYCURLS][item] = [requestData.data[PREFIX_KYCURLS][item]];
        } else if (!requestData.data[PREFIX_KYCURLS][item]) {
            requestData.data[PREFIX_KYCURLS][item] = null;
        }
    })

    return requestData;

}

export const uboFormDefaultSetData = (requestData, uniqueIdentifier) => {
    requestData.uniqueIdentifier = uniqueIdentifier;
    requestData.formType = MLE_CREATE_FORM_NAME;
}

export const uboSubmitDataFormat = (formData, uniqueIdentifier, intentId) => {
    
    const requestData = {};
    // in case of single email
    uboFormDefaultSetData(requestData, uniqueIdentifier);
    
    requestData.sectionType = UBO_SECTION_TYPE;
    requestData.intentId = intentId;
    requestData.data = JSON.parse(JSON.stringify(formData));
    
    // requestData.data.name = requestData.data.uboPaNName;
    delete requestData.data.ubodeclarationsFile;
    
    if (requestData.data.uboDeclarationUrls)
        requestData.data.uboDeclarationUrls = updateDataToArr(formData.uboDeclarationUrls);
    if (requestData?.data?.filteredEditedCategoryIdx)
        delete requestData.data.filteredEditedCategoryIdx;
    if (requestData?.data?.infoMsgs)
        delete requestData.data.infoMsgs;
    
    if (typeof requestData?.data?.uboDetails === 'object' && requestData.data.uboDetails.length) {
        
        requestData.data.uboDetails.map((item, index) => {
            // let itemData = {...item};
            // let name = itemData.uboPANName;
            
            // requestData.data.uboDetails[index].name = name;
            
            delete requestData.data.uboDetails[index].uboPanUpload;
            delete requestData.data.uboDetails[index].panurl;
            
            // delete requestData.data.uboDetails[index].uboPANName;
            
            delete requestData.data.uboDetails[index].addressFile;
            if (requestData.data.uboDetails[index]?.['verify-pan']) {
                delete requestData.data.uboDetails[index]['verify-pan'];
            }

            if (requestData.editedDocCategory) 
                delete requestData.editedDocCategory;
            if (requestData.infoMsgs)
                delete requestData.infoMsgs;
            
            requestData.data.uboDetails[index].dob = adjustDateToTimezone(requestData.data.uboDetails[index].dob);
        })
    }
    
    
    // if (requestData?.data?.panNumberUpload) {
    //     delete requestData.data.panNumberUpload;
    // }
    // if (requestData?.data?.gstUpload) {
    //     delete requestData.data.gstUpload;
    // }

    return requestData;

}

export const removeDuplicates = (array, key) => {
    const seen = new Set();
    return array.filter((item) => {
        const value = typeof key === "function" ? key(item) : item[key];
        if (seen.has(value)) {
        return false;
        }
        seen.add(value);
        return true;
    });
};

export const fetchFieldValue = (values, name) => {
    
    let resp = values ? createDeepCopyObj(values) : null;
    try {
        let nameHierarchy = name?.split(/[\.\[\]]/)?.filter(Boolean);
    
        if (nameHierarchy) {
            nameHierarchy.map(item => {
                if (resp) {
                    
                    resp = resp[item];
                }
            })
        }
        
        
    } catch(e){
        console.log("error", e.message);
    }
    
    return resp;


}

export const setFieldValue = (obj, path, value) => {
    if (!value) {
        return;
    }
    const keys = path.split('.'); // Split the path into keys
    let current = obj;

    // Iterate through the keys and create nested objects if necessary
    for (let i = 0; i < keys.length - 1; i++) {
        const key = keys[i];
        if (!current[key]) {
        current[key] = {}; // Create an empty object if key does not exist
        }
        current = current[key]; // Move to the next level
    }

    if (!current[keys[keys.length - 1]]) {
        current[keys[keys.length-1]] = '';
    }
    // Set the value at the final key
    if (typeof value === 'object' && !Array.isArray(value))
        current[keys[keys.length - 1]] = value;
    else 
        current[keys[keys.length - 1]] += value; // handling arrays
}

export const allowedExtensions = ['jpg', 'jpeg', 'png', 'svg', 'pdf'];
export const allowedImgExtensions = ['jpg', 'jpeg', 'png', 'svg'];

export const defaultOption = [{
    name: 'Please select an option',
    value: ''
}];

export const defaultOptionDoc = [{
    docName: 'Please select an option',
    docType: ''
}];

export const FIELD_TYPES = {
    constitutionType: "constitutionType",
    pinCode: "pinCode"
}

export async function handleViewClick(docUrl, setIsUploading, setSelectedDocument, setDocTimeStamp, createdAt) {
    const request = {
        s3Path: Array.isArray(docUrl) ? docUrl[0] : docUrl,//TODO need to check
    };
    try {
        setIsUploading(true);
        const response = await POST(
            API_VIEW_KYC_DOCUMENT,
            request,
            {},
            true
        );
        const { data } = response;
        
        // return 'src/static/images/generating.gif';
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            setIsUploading(false);
            if (setSelectedDocument)
                setSelectedDocument(data.s3Url);
            if (setDocTimeStamp) {
                setDocTimeStamp(getTimeStampFromUrl(request.s3Path, createdAt));
            }
                return data.s3Url;
        } else {
            toast.error(ERROR_MESSAGES.FALLBACK_ERROR);
        }
    } catch (error) {
        toast.error(ERROR_MESSAGES.FALLBACK_ERROR);
        setIsUploading(false);
    }
    return ''
}

export async function handleUploadKycImage(file, setIsUploading, actions, name, formName, isEditMode, entityId, fieldName) {
    
    setIsUploading(true);
    let data;
        
    try {
        if (MOCK_API_VALUE) {
            toast.info('File upload successful');
            let resp = kycDocumentsUploadRes(KYC_DOCUMENT_UPLOAD_SUCCESS);
            
            // setIsUploading(false);
            data =resp;
            // return resp?.data?.s3Url;
        } else {

            const formData = new FormData();
            formData.append('multipartFile', file);
            if (isEditMode)  {
                formData.append('merchantId', entityId);
                formData.append('docType', fieldName);
                formData.append('entityType', 'MLE');
            }
            const response = await POST(
                API_UPLOAD_KYC_DOCUMENT,
                formData,
                {
                    'Content-Type': 'multipart/form-data;',
                },
                true
            );
    
            data = response?.data || {};
        }
        
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            
            if (name) {
                actions.change(formName, name, [data.s3Path]);
            }
            // toast.info('File upload successful');
            setIsUploading(false);
            return data.s3Path;
        }
        toast.error(ERROR_MESSAGES.FALLBACK_ERROR);
    } catch (error) {
        toast.error(ERROR_MESSAGES.FALLBACK_ERROR);
    }
    setIsUploading(false);
}

export const isAllErrorFixed = (errors) => {
    
    let res = true;
    try {
        Object.keys(errors).map(item => {
            if (res) {
                
                if (typeof errors[item] === 'string' && errors[item]) {
                    
                    res = false;
                    
                }
                if (typeof errors[item] === 'object') {
                    const checkIsAllFixed = isAllErrorFixed({...errors[item]});
                    
                    if (!checkIsAllFixed) {
                        res = false;
                    }
                }
            }
        })
    } catch (e){
        console.log("e message", e.message);
    }
    return res;
}

export const onNext = (history, nextPath) => {
    history.push(nextPath);
}

export const THRESHOLD_HIGH = 90;
export const THRESHOLD_MEDIUM = 70;

export const getDataBasedConfidenceScore = (data) => {
    try {
        if (parseInt(data?.confindance_score) > THRESHOLD_HIGH) {

        } else if (parseInt(data?.confindance_score) > THRESHOLD_MEDIUM) {

        } else {

        }
    } catch(e) {

    }

}

const triggerInputEventWithMessage = (fieldId, errorMessage) => {
    const inputElement = document.getElementById(fieldId);
    if (inputElement) {
        // Trigger the input event
        const event = new Event("input", { bubbles: true });
        inputElement.dispatchEvent(event);

        // Find the error message container within the same parent
        const inputContainer = inputElement.closest(".input-container");
        if (inputContainer) {
            let errorElement = inputContainer.querySelector(".error-message");
            if (!errorElement) {
                // Create the error message element if it doesn't exist
                errorElement = document.createElement("span");
                errorElement.className = "sc-fzplWN bCqQxr error-message";
                inputContainer.appendChild(errorElement);
            }
            // Update the error message
            errorElement.textContent = errorMessage;
        }
    } else {
        console.warn(`Element with id "${fieldId}" not found.`);
    }
};
let toastShown = false;
export const isPanVerifyDisable = (piiData) => {
    let panUploaded = piiData[PAN];
    let documentDetails = panUploaded?.documentDetails;
    if (documentDetails) {
        let pan = documentDetails.panNumber?.value;
        let panName = documentDetails.name?.value;
        let panDate = documentDetails.dob?.value;
        
        let panError = fieldLevelValidators.pan(pan);
        
        if (panError && !toastShown) {
            // Show toast only if it hasn't been shown
            // toast.error(panError);
            toastShown = true; // Set the flag to true
        } else if (!panError) {
            // Reset the flag when there are no errors
            toastShown = false;
        }
        return !pan || !panName || !panDate || !!panError;
    }
    return true;
}

// export const isGstVerifyDisable = (values, isDisable) => {
//     let gst = fetchFieldValue(values, mleFields.gst.name);

//     // add gst validation
//     // if error it will return string
//     let gstError = fieldLevelValidators.gst(gst);
        
//     return !gst || isDisable || !!gstError;
// }


export const isGstVerifyDisable = (values, isDisable, businessType) => {
    
    // If business type is sole proprietorship, GST verification is optional
    // So we disable the verify button only if there's no GST number (but verification isn't mandatory)
    if (businessType === 'MOB_SOLE_PROPRIETORSHIP') {
        let gst = fetchFieldValue(values, mleFields.gst.name);
        return !gst; // Only disable if GST field is empty (but don't block verification if GST exists)
    }
    
    // Original logic for other business types
    let gst = fetchFieldValue(values, mleFields.gst.name);
    let gstError = fieldLevelValidators.gst(gst);
        
    return !gst || isDisable || !!gstError;
}


export const VERIFIED = "VERIFIED";

// export const isSaveSubmitDisable = (isPiiVerified) => {
//     let panVerify = isPiiVerified?.[PAN]?.verifiedStatus === VERIFIED;
//     let gstVerify = isPiiVerified?.[GST]?.verifiedStatus === VERIFIED;
//     return !panVerify || !gstVerify;

// }


export const isSaveSubmitDisable = (isPiiVerified, businessType, currentGstValue) => {
    let panVerify = isPiiVerified?.[PAN]?.verifiedStatus === VERIFIED;
    let gstVerify = isPiiVerified?.[GST]?.verifiedStatus === VERIFIED;
    let gstValue = isPiiVerified?.[GST]?.documentDetails?.gstNumber?.value || "";
    // If business type is sole proprietorship, individual and trust, only PAN verification is required
    if (businessType === 'MOB_SOLE_PROPRIETORSHIP' || businessType ==='INDIVIDUAL' || businessType === 'TRUST') {
        if (!currentGstValue || gstValue === GST_ERROR_MSG) {
        
            // If GST is not provided, we don't need to check its verification status
            return !panVerify;
        }
    }
    
    // For other business types, both PAN and GST verification are required
    return !panVerify || !gstVerify;
}


export const handleVerifyPiiAccount = async (e, props) => {
    const {
        type,
        piiData,
        setIsUploading,
        setIsPiiVerified,
        setIntentId,
        intentId,
        actions,
        formName,
        verifyFieldName,
        setVerifiedDetails
    } = props;
    e.preventDefault();
    setIsUploading(true);
    try {            
        let payload = {
            verificationId: '',
            accountType: type,
            accountIdentifier: ''
        };
        let error = '';
        
        let panUploaded = piiData[PAN];
        let gstUploaded = piiData[GST];
        
        if (type === PAN && panUploaded?.documentDetails) {
            let documentDetails = panUploaded?.documentDetails;
            let dob = moment(documentDetails.dob?.value).format(FORMAT_DATE);
            let pan = documentDetails.panNumber?.value;
            let panName = documentDetails.name?.value;
            let panDate = dob;
            
            
            error = verifyPanDetails({pan, panName, panDate});

            payload.verificationId = (intentId) ? intentId : null;
            payload.accountIdentifier = pan;
            payload.kycMetaData = {
                name: panName,
                dob: panDate
            };

        } else if (type === GST && gstUploaded?.documentDetails) {
            let documentDetails = gstUploaded?.documentDetails;
            let gst = documentDetails?.gstNumber?.value;
            error = verifyGstDetails(gst);
            payload.verificationId = (intentId)? intentId : panUploaded?.documentDetails.panNumber?.value; 
            payload.accountIdentifier = gst;
        }
        
        // fields error
        if (error) {
            toast.error(error);
            // return;
        } else {
            
        let response = await verifyAccountDetails(payload, type);
        
        if (response.intentId && !intentId && setIntentId) {
            setIntentId(response.intentId);
        }

        if (response.statusCode === apiStatusCodes.SUCCESS && verifyFieldName) {
            actions.change(formName, verifyFieldName, true); 
        }
            
            setIsPiiVerified((prev) => {
                let item = {...prev};
                item[type].verifiedStatus = response.statusCode === apiStatusCodes.SUCCESS ? 'VERIFIED' : '';
                
                return {...item};
            });
            if (setVerifiedDetails && response.statusCode === apiStatusCodes.SUCCESS) {
                // saving the verified details
                setVerifiedDetails((prev) => {
                    let item = {...prev};
                    if (type === PAN) {
                        item[type] = createDeepCopyObj(panUploaded);
                    } else if (type === GST) {
                        item[type] = createDeepCopyObj(gstUploaded);
                    }
                    return {...item};
                })
            }
        }
    } catch(e) {
        toast.error(ERROR_FETCH)
    }
    setIsUploading(false);
}

export const handleDeleteFile = (name, formName, actions) => {
    try {
        
        actions.change(formName, name, null);
    } catch(e) {
        console.log("e delete", e);
    }   
}

export const getActiveCount = (activeCount) => {
    if (typeof activeCount === 'object') {
        return activeCount.filter(item=>item).length === MAX_ACTIVE_UBO_COUNT;
    } 
    return 0;
}

export const checkPiiData = (piiData, type, field) => {
    try {

        if (!piiData[type].documentDetails) {
            piiData[type].documentDetails = {}
        }
        if (!piiData[type].documentDetails[field]) {
            piiData[type].documentDetails[field] = {};
        }
    } catch(e) {
        console.log("e", e);
    }
}

export const showCheckerRemark = (checkerRemarks, key) => {
    try {
        if (checkerRemarks[key] && checkerRemarks[key].remarks) {
            return checkerRemarks[key].remarks;
        }
        return undefined;
    }
    catch(e) {}
}

export const fetchUboActiveFlag = (uboFormData) => {
    try {
        
        if (typeof uboFormData?.values?.uboDetails === 'object' && uboFormData?.values?.uboDetails?.length) {

            let  data = uboFormData.values.uboDetails?.map(item => item?.status === UBO_ACTIVE_FIELDS.ACTIVE ?? false);
            
            return data;
        }

    } catch(e) {
        console.log("fetchUboActiveFlag", e);
    }
    return [];
}

export const UBO_ACTIVE_FIELDS = {
    ACTIVE: 'ACTIVE',
    INACTIVE: 'INACTIVE'
}

export const updateIsInvalidButton = (setInvalidButton, field, flag) => {
    try {
        setInvalidButton((curr) => {
            curr[field] = flag;
            return curr;
        })
    } catch(e) {
        console.log("updateIsInvalidButton", e);
    }
}

export const getInitialUrlVal = (values, field) => {
    try {

    } catch(e) {

    }
}

export const configPiiField = (prev, curr, type, checkerRemarks, isEditMode, fields) => {
    try {
        let dobEditable = !isApproved(checkerRemarks, fields?.panDate?.name, null, isEditMode);
        let panEditable = !isApproved(checkerRemarks, fields?.pan?.name, null, isEditMode);
        let panNameEditable = !isApproved(checkerRemarks, fields?.panName?.name, null, isEditMode); 

        if (!dobEditable) {
            curr.documentDetails['dob'].value = prev[type].documentDetails['dob'].value;
        }
        if (!panEditable) {
            curr.documentDetails['panNumber'].value = prev[type].documentDetails['panNumber'].value;
        }
        if (!panNameEditable) {
            curr.documentDetails['name'].value = prev[type].documentDetails['name'].value;
        }
    } catch(e) {
        console.log("configPiiField", e);
    }
}

export const handlePiiUpload = async (props) => {
    const {
        file, 
        type, 
        name, 
        actions, 
        setPiiData, 
        setIsPiiVerified, 
        setIsUploading,
        formName,
        isEditMode,
        entityId,
        checkerRemarks,
        fields
    } = props;
    setIsUploading(true);
    let url = '';
    try {
        const formData = new FormData();
        formData.append('multipartFile', file);
        formData.append('docType', type);
        if (isEditMode) {
            formData.append('entityId', entityId);
        }
        const piiData = await fetchPiiData(formData, type);
        
        if (type === PAN) {
            checkPiiData({PAN: piiData}, PAN, 'dob')
            checkPiiData({PAN: piiData}, PAN, 'panNumber')
            checkPiiData({PAN: piiData}, PAN, 'name')
        } else {
            checkPiiData({GST: piiData}, GST, 'gstNumber')
        }
        
        setPiiData(prev => {
            const setData = {};
            if (type === PAN) 
                configPiiField(prev, piiData, type, checkerRemarks, isEditMode, fields);
            setData[type] = piiData;


            
            return { ...prev, ...setData };
        });
        setIsPiiVerified(prev => {
            let item = {};
            item[type] = { ...piiData, verifiedStatus: '' };
            return { ...prev, ...item };
        });
        actions.change(formName, name, piiData.s3Path);
        
        url = piiData.s3Path;
    } catch (e) {
        toast.error(ERROR_FETCH);
    }
    setIsUploading(false);
    return url;
    // actions.panUploadAndFetchProcessV1();
};

const initialValueUploadData = {
    s3Url:'',
    s3Path: '',
    documentDetails: {
        panNumber: { value: '' },
        dob: { value: '' },
        name: { value: '' },
        fatherName: { value: '' },
        gstNumber: { value: '' },
    },
};

export const setInitialPiiData = (props) => {
    try {
        
            const { values, fields } = props;
            
            let panData = {};
            let gstData = {};

            let pan = fetchFieldValue(values, fields.pan.name) || '';
            
            let panName = fetchFieldValue(values, fields.panName.name) || '';
            let panDate = fetchFieldValue(values, fields.panDate.name) || fetchFieldValue(values, 'panDetails.dob') || null;
            let panUrl = fetchFieldValue(values, fields.panUpload.reqname) || '';
            
            // if (pan && panName && panDate) {
                
                panData = createDeepCopyObj(initialValueUploadData);
                panData.s3Url = panUrl;
                panData.s3Path = panUrl;
                panData.documentDetails.panNumber.value = pan;
                panData.documentDetails.dob.value = panDate;
                panData.documentDetails.name.value = panName;
                
                if (fields?.gst?.name) {
                    
                    let gstNumber = values?.gstNumber;
                    let gstUrl = values?.gstUpload;

                    if (gstNumber && gstUrl) {
                        
                        gstData = createDeepCopyObj(initialValueUploadData);
                        gstData.s3Url = gstUrl;
                        gstData.s3Path = gstUrl?.value?.name || gstUrl;
                        gstData.documentDetails.gstNumber.value = gstNumber.toString();
                        
                    }
                }
                
                return {
                    GST: gstData,
                    PAN: panData
                }
            // }
        } catch(e) {

    }
    return {
        GST: {},
        PAN: {}
    };

}

export const setInitialVerifiedData = ({values = {}, fields = {}, checkerRemarks, isEditMode}) => {
    try {

        let piiData = setInitialPiiData({values, fields})
        // UBO DETAILS CASE when pan is not available
        if (!piiData?.[PAN]?.documentDetails?.panNumber?.value) {
            return piiData;
        }
        // business details case will not work in ubo as ubo values have diff hierarchy
        if (values?.gstNumber ==='' && Object.keys(values.panDetails || {}).length !== 0) {
            piiData[GST].verifiedStatus = 'VERIFY';
            piiData[PAN].verifiedStatus = VERIFIED;
            return piiData;
        }
    
        // DRAFT DATA CASE - works in business details
        if (!checkerRemarks) {
            if (!!values?.gstNumber) 
                piiData[GST].verifiedStatus = VERIFIED;
            if (fetchFieldValue(values, fields?.verifyPan?.name || mleFields.verifyPan.name))
                piiData[PAN].verifiedStatus = VERIFIED;
            return piiData;
        }
        // Edit mode case - works in business details
        if (isEditMode) {
            // new button implementation
            if (fetchFieldValue(values, fields?.verifyPan?.name || mleFields.verifyPan.name)) {
                piiData[PAN].verifiedStatus = VERIFIED;
            }
            if (fetchFieldValue(values, fields?.verifyPan?.name || mleFields.verifyGst.name)) {
                piiData[GST].verifiedStatus = VERIFIED;
            }
        }
        // maker data case
        if (fields?.gst?.name) {
            if (isApproved(checkerRemarks, fields.gst.name)) {         
            piiData[GST].verifiedStatus = VERIFIED;
            }
        }
        
        // maker and edit mode case -- works with both
        if (isApproved(checkerRemarks, fields.panUpload.reqname) && 
        isApproved(checkerRemarks, fields.pan.name) &&
        isApproved(checkerRemarks, fields.panName.name) &&
        isApproved(checkerRemarks, fields.panDate.name)) {         
            piiData[PAN].verifiedStatus = VERIFIED;
        }
        return piiData;
    } catch(e) {
        console.log("setInitialVerifiedData", e?.message);
    }
}

export const isApproved = (data, key, prefix = null, isEditMode) => {
    
    try {
        let checkData = data;
        if (typeof data === 'object' && key) {
            if (prefix) {

                checkData = data[`${prefix}${key}`].status ?? '';
            } else {
                checkData = data[key.replace(/\[/g, '.').replace(/\]/g, '')]?.status ?? '';
            }

        }
        if (checkData?.includes(APPROVE) || (isEditMode && !checkData?.includes(EDITABLE    ))) {
            
            return true;
        }
        
    } catch(e) {
        console.log("isApproved", e);
    }
    return false;
}

export const isRejected = (data, key, prefix = null) => {
    try {
        let checkData = data;

        if (typeof data === 'object' && key) {
            if (prefix) {
                checkData = data[`${prefix}${key}`]?.status ?? '';
            } else {
                checkData = data[key.replace(/\[/g, '.').replace(/\]/g, '')]?.status ?? '';
            }
        }

        if (checkData && checkData === "REJECT") {
            return true;
        }
    } catch (e) {
        console.log("isRejected", e);
    }
    return false;
};


export const redClassRemarksCond = (checkerRemarks, fieldName, isEditMode, noShowRed) => {
    try {
        if (noShowRed)
            return '';
        if (!isEditMode && checkerRemarks?.[replaceSquareBraces(fieldName)] && !isApproved(checkerRemarks, fieldName)) {
            return 'red-txt';
        }
    }
    catch {}
    return '';
}

export const isUboTabNotEmpty = (data) => {  
    try {
        
        if(typeof data === 'object') {
            let keys = Object.keys(data);
            if (keys.length === 0) {
                return false;
            } else if (keys.length === 1 && keys[0] === 'status') {
                return false;
            }
        } else {
            return false;
        }
    } catch(e) {

    }
    return true;
}

export const hasDuplicates = (arr) => {
    return new Set(arr).size !== arr.length;
}


export async function handleViewClickReturnUrl(docUrl) {
    const request = {
        s3Path: docUrl,
    };

    
    try {
        // setIsUploading(true);
        const response = await POST(
            API_VIEW_KYC_DOCUMENT,
            request,
            {},
            true
        );
        const { data } = response;
        
        // return 'src/static/images/generating.gif';
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            // if (data.s3Url.toLowerCase().includes('.pdf')) {
            //     window.open(data.s3Url);
            // } else {
            // if (setSelectedDocument)
            //     setSelectedDocument(data.s3Url);
            console.log("ddddd", data.s3Url);
            return data.s3Url;
            // }
        } else {
            toast.error(ERROR_MESSAGES.FALLBACK_ERROR);
        }
        // setIsUploading(false);
    } catch (error) {
        toast.error(ERROR_MESSAGES.FALLBACK_ERROR);
        // setIsUploading(false);
    }
    return ''
}

export const getFileListUrls = async (urlList) => {
    const urls = [];
    try {
        
        for (let i = 0; i < urlList.length; i++) {
            const url = await handleViewClickReturnUrl(urlList[i]);
            urls.push(url);
            
        }
        
    } catch(e) {
        console.log("ure", e);
    }
    
    return urls;
}

export const mapCheckerRemarksKeyWithNames = (key) => {
    try {
        const keysToUpdate = [
            'uboDeclarationUrls', 
            'addressProofUrls', 
            PREFIX_KYCURLS, 
            'GST', 
            'pandetails.url', 
            'emails',
            'gstNumber',
            'websiteURLs',
            'telephoneNumbers',
            'mobileNumbers'
        ];
        if (!!keysToUpdate.find(item => key.includes(item))) {
            let keyArr = key.split('.');
            if (!isNaN(keyArr[keyArr.length-1])) 
                return key.split('.').slice(0, -1).join('.');
        }
        return key;
    } catch(e) {
        toast.error(e?.message || "");
    }
}

const compareArrUploadFiles = (data, initialData, key, prefix, infoMsgs) => {
    let prev = initialData?.[key]?.join(',') ?? '';
    let curr = data?.[key]?.join(',') ?? '';
    if (prev !== curr) {
        infoMsgs[`${prefix}.${key}`] = `${key} is updated`;
    }
}

export const verifyUpdateFormChange = (initialValues, values, prefix='') => {
    let infoMsgs = {};
    try {
        
        const skipKeys = ['panurl', 'gstUpload', 'kycfiles', 'kycDocUrls', 'editedDocCategory', 'infoMsgs', 'mandatoryDocs', 'partiallyMandatoryDocs', 'addressProofUrls'];
        const skipNewKeys = ['optionalFields'];

        const PREFIX_KYC = 'kycDocUrls';
        const multiFields = [PREFIX_KYC];
        if (values?.['addressProofUrls'] && initialValues?.['addressProofUrls']) {
            compareArrUploadFiles(values, initialValues, 'addressProofUrls', prefix.slice(0,-1), infoMsgs);
        }
        if (values?.[PREFIX_KYC]) {
            for (const key in values[PREFIX_KYC]) {
                compareArrUploadFiles(values[PREFIX_KYC], initialValues[PREFIX_KYC], key, PREFIX_KYC, infoMsgs);
            }
        }
        for (const key in initialValues) {
            if (!skipKeys?.includes(key)) {
                let prev = initialValues?.[key];
                let curr = values?.[key];
                if (multiFields.includes(prefix)) {
                    prev = initialValues?.[key]?.join(',');
                    curr = values?.[key]?.join(',');
                }
                if (typeof prev === 'object' && typeof curr === 'object') {
                    let isMatchedObject = verifyUpdateFormChange(initialValues[key], values[key], prefix+key+'.');
                    infoMsgs = {...infoMsgs, ...isMatchedObject};
                } else {
                    curr = (curr || typeof curr === 'number') ? curr.toString() : curr;
                    prev = (prev || typeof prev === 'number') ? prev.toString() : prev;
                    if (!values || curr != prev) {
                        // set the msg
                        
                        if (prefix.includes('uboDetails')) {
                            let field = Object.values(uboFields).find(item => {
                                let prefixUboUpdated = prefix.slice(0, -1);
                                let replaceArrayItems = ['.panDetails', '.address'];
                                if (replaceArrayItems.some(item => prefixUboUpdated.includes(item))) {
                                    
                                    replaceArrayItems.forEach(item => {
                                        prefixUboUpdated = prefixUboUpdated.replace(item, '');
                                    });
                                }
                                
                                
                                
                                if (item.reqname)
                                    return item?.name(prefixUboUpdated) === `${prefix}${key}` ||  item?.reqname(prefixUboUpdated) === `${prefix}${key}`;
                                else 
                                    return item?.name(prefixUboUpdated) === `${prefix}${key}`;
                            })
                            
                            infoMsgs[`${prefix}${key}`] = field?.infoMsgs;
                        } else if (key === 'uboDeclarationUrls') {
                            infoMsgs[`${prefix}${key}`] = uboDeclarationUrls?.infoMsgs;
                        } else {
                            let field = Object.values(mleFields).find(item => {
                                
                                
                                //     item?.name === `${prefix}${key}`, item?.reqname === `${prefix}${key}`, item?.reqName === `${prefix}${key}`
                                // );
                                return item?.name === `${prefix}${key}` || item?.reqname === `${prefix}${key}` || item?.reqName === `${prefix}${key}`
                            })
                            
                            infoMsgs[`${prefix}${key}`] = field?.infoMsgs;
                        }
                        if (!infoMsgs[`${prefix}${key}`]) {
                            infoMsgs[`${prefix}${key}`] = `${key} is updated`
                        }
                       
                    }
                }
            }
        }

        // Handle new fields in `values` not present in `initialValues`
        for (const key in values) {
            if (!initialValues?.hasOwnProperty(key) && ![...skipKeys, ...skipNewKeys]?.includes(key)) {
                const fullKey = `${prefix}${key}`;
                infoMsgs[fullKey] = `${key} is added`;
            }
        }

    } catch(e) {
        // toast.error(e.message);
        console.log("e", e);
    }
    
    // reset the msg
    return infoMsgs;
}

export const setUboTabFormData = (formValues, uniqueIdentifier) => {
    try {
        let requestData = {};
        requestData.uniqueIdentifier = uniqueIdentifier;
        requestData.formType = MLE_CREATE_FORM_NAME;
        requestData.data = createDeepCopyObj(formValues);
        return requestData;
    } catch(e) {
        toast.error("Error while creating the payload", e?.message);
    }
    return {}
}

export const replaceSquareBraces = (value) => {
    try {
        return value.replace(/\[/g, '.').replace(/\]/g, '');
    }
    catch(e) {
        console.log("e", e);
    }
    return value
}

// in edit mode check which uploadabled fields are editable
// based on category or key
export const checkKycDocsEditable = (remarks, editedFields) => {
    try {
        // console.log("remarks keyName editedFields", remarks, keyName, editedFields);
        // case where remarks not exist then is edit mode 
        if (!remarks || typeof remarks !== 'object') {
            return ['all'];
        }
        // check if category exist
        // remarks and editable fields are used to doc category
        const categorySet = new Set([]);
        Object.keys(editedFields).map(item => {
            if (remarks?.[item]?.docCategory?.length) {
                remarks[item].docCategory.map(category => {
                    categorySet.add(category);
                })
            }
        })
        return [...categorySet];
    } catch(e) {
        console.log(e);
    }
    return [];
}

export const comparePanDetails = (panDetails, currPanDetails, fields) => {
    try {
        let verifiedPan, verifiedName, verifiedDob;
        if (panDetails?.documentDetails) {
            let documentDetails = panDetails?.documentDetails;
            verifiedDob = moment(documentDetails.dob?.value).format(FORMAT_DATE);
            verifiedPan = documentDetails.panNumber?.value;
            verifiedName = documentDetails.name?.value;
        }
        let currPan = fetchFieldValue(currPanDetails, fields.pan.name) || null;
        let currName = fetchFieldValue(currPanDetails, fields.panName.name) || null;
        let currDob = fetchFieldValue(currPanDetails, fields.panDate.name) || null;
        if (verifiedPan !== currPan || verifiedName !== currName || verifiedDob !== currDob) {
            return false;
        } else {
            return true;
        }
    } catch(e) {
        console.log("comparePanDetails", e);
    }
}

export const getTimeStampFromUrl = (url, defaultStamp = null) => {
    let timeStampUrl = url;
    if (Array.isArray(url)) {
        // find the max time stamp
        timeStampUrl = url.reduce((max, item) => {
            const spliturl = item.split('/');
            if (spliturl.length > 2) {
                const timeStamp = spliturl[spliturl.length - 2];
                return Math.max(max, Number(timeStamp));
            }
            return max;
        }, defaultStamp);
    }
    if (!timeStampUrl || (typeof timeStampUrl !== 'string' && typeof timeStampUrl !== 'number'))
        return defaultStamp;

    if (typeof timeStampUrl === 'string') {
        const spliturl = timeStampUrl.split('/');
        if (spliturl.length > 2) {
            timeStampUrl = spliturl[spliturl.length - 2];
            if (isNaN(timeStampUrl)) {
                return defaultStamp;
            }
        } else {
            return defaultStamp;
        }
    }
    return Number(timeStampUrl);
}

export const convertTimeStampToFormattedDate = (timeStamp, format = FORMAT_DATE_TIME) => {
    return moment(Number(timeStamp)).format(format);
}

export const getFormattedDateusingUrl = (url, defaultStamp) => {
    let formattedDate = '';
    if ((Array.isArray(url) && url.length > 0) || (typeof url === 'string' && url.trim() !== '')) {
        const timeStamp = getTimeStampFromUrl(url, defaultStamp);
        if (timeStamp) {
            formattedDate = convertTimeStampToFormattedDate(timeStamp);
        }
    }
    return formattedDate;
}